import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceEvent } from 'src/app/data/model/device-event';

@Component({
  standalone: false,
  selector: 'app-event-dialog-smart-bin',
  templateUrl: './event-dialog-smart-bin.component.html',
  styleUrls: ['./event-dialog-smart-bin.component.scss']
})
export class EventDialogSmartBinComponent implements OnInit {

  public get displayedColumns(): string[] {
    return ['device_timestamp', 'event_type', 'notes']
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DeviceEvent[]
  ) { }

  ngOnInit(): void {
  }

}

export type SmartBinEventDialogParams = {
  data: any;
  device:string;
};